import { parseErrorResponse } from "./errors";

/**
 * Performs a fetch call, checks for errors, and processes the response.
 *
 * @param path - The URL to fetch
 * @param options - Optional fetch options
 * @param parser - An optional parser function for processing the response
 * @returns The processed response of type T
 */
export async function baseFetch<T>(
  url: string,
  options?: RequestInit,
  parser?: (response: Response) => Promise<T>,
): Promise<T> {
  const response = await fetch(url, { credentials: "include", ...options });

  if (!response.ok) {
    const error = await parseErrorResponse(response);
    throw error;
  }

  return parser ? parser(response) : response.json();
}
